import { Outlet } from "react-router-dom";

const CommunicationMainPage = () => {
    return <Outlet />;
}

export default CommunicationMainPage;